import { opaccLogPlugin } from '../opacc.static.js';

/** @module static */

/**
 * Daten asynchron laden und senden
 *
 */
export class OpaccAjax {
	constructor() {}

	/**
	 * Fetch async data
	 *
	 * @param {*} reqUrl
	 * @param {*} init
	 * @param {*} returnFnc
	 * @param {*} errorFnc
	 * @param {boolean} [forceResponseAsJson=false]
	 */
	fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson = false) {
		fetch(reqUrl, init)
			.then(this.getRespContentType)
			.then(forceResponseAsJson ? this.processJsonResponse.bind(this) : this.doNothing)
			.then(returnFnc)
			.catch(error => { errorFnc(error); });
	}

	/**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} inputData
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */
	fetchAsynPostForm(reqUrl, inputData, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
		let headers = new Headers({
			'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
			'x-requested-with': 'XMLHttpRequest'
		});

		const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content') || '';
		if (csrfToken.length > 0) {
			headers.append('XSRF-TOKEN', csrfToken);
		}

		let init = this.getDefaultPostInitObj(headers, this.objectToQuerystring(inputData), forceResponseAsJson);
		this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
	}

	/**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} inputData
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */
	fetchAsynPostJson(reqUrl, inputData, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
		let headers = new Headers({
			'content-type': 'application/json; charset=UTF-8',
			'x-requested-with': 'XMLHttpRequest'
		});

		const csrfToken = document.querySelector("meta[name='csrf-token']")?.getAttribute('content') || '';
		if (csrfToken.length > 0) {
			headers.append('XSRF-TOKEN', csrfToken);
		}

		let init = this.getDefaultPostInitObj(headers, inputData, forceResponseAsJson);
		this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
	}

	/**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */
	fetchAsynGetForm(reqUrl, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
		let init = this.getDefaultGetInitObj(null, forceResponseAsJson);
		this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
	}

	/**
	 *
	 *
	 * @param {*} reqUrl
	 * @param {*} returnFnc
	 * @param {*} [errorFnc=this.getDefaultErrorFnc]
	 * @param {boolean} [forceResponseAsJson=false]
	 */
	fetchAsynGetJson(reqUrl, returnFnc, errorFnc = this.getDefaultErrorFnc, forceResponseAsJson = false) {
		let init = this.getDefaultGetInitObj(null, forceResponseAsJson);
		this.fetchAsync(reqUrl, init, returnFnc, errorFnc, forceResponseAsJson);
	}

	/**
	 *
	 *
	 * @param {*} resp
	 * @returns {*}
	 */
	getRespContentType(resp) {
		let contentType = resp.headers.get('content-type');
		return contentType && contentType.includes('application/json') ? resp.json() : resp.text();
	}

	/**
	 *
	 *
	 * @param {*} error
	 */
	getDefaultErrorFnc(error) {
		// eslint-disable-next-line no-console
		console.error('Request failed: ', error);
	}

	/**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */
	getDefaultGetInitObj(headers = null, forceResponseAsJson = false) {
		let init = {
			method: 'GET',
			credentials: 'include',
			headers: headers
		};

		if (headers === null) {
			init.headers = new Headers({
				'x-requested-with': 'XMLHttpRequest'
			});
		}

		if (forceResponseAsJson) {
			init.headers.set('response-type', 'json');
		}

		return init;
	}

	/**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {string} [body='']
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */
	getDefaultPostInitObj(headers = null, body = '', forceResponseAsJson = false) {
		let init = this.getDefaultGetInitObj(headers, forceResponseAsJson);
		init.method = 'POST';
		init['body'] = body;

		return init;
	}

	/**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */
	getDefaultGetInitObjExternal(headers = null, forceResponseAsJson = false) {
		let init = this.getDefaultGetInitObj(headers, forceResponseAsJson);
		delete init.credentials;
		return init;
	}

	/**
	 *
	 *
	 * @param {*} [headers=null]
	 * @param {string} [body='']
	 * @param {boolean} [forceResponseAsJson=false]
	 * @returns {*}
	 */
	// eslint-disable-next-line no-unused-vars
	getDefaultPostInitObjExternal(headers = null, body = '', forceResponseAsJson = false) {
		let init = this.getDefaultPostInitObj(headers, body, forceResponseAsJson);
		delete init.credentials;
		return init;
	}

	/**
	 *
	 *
	 * @param {*} obj
	 * @returns {*}
	 */
	objectToQuerystring(obj, encode = true, encodeUriComponent = true) {
		return Object.keys(obj).reduce(function(str, key, i) {
            let encodeKey = encodeUriComponent ? encodeURIComponent(key) : encodeURI(key);
            let encodeObjKey = encodeUriComponent ? encodeURIComponent(obj[key]) : encodeURI(obj[key]);
			let delimiter, val;
			delimiter = i > 0 ? '&' : '';
			key = encode ? encodeKey : key;
			val = encode ? encodeObjKey : obj[key];
			return [str, delimiter, key, '=', val].join('');
		}, '');
	}

	/**
	 *
	 *
	 * @param {*} response
	 * @returns {*}
	 */
	processJsonResponse(response) {

		// Daten Base64-dekodieren
        let data = this.base64DecodeUnicode(response.data);

		// Daten HTML-dekodieren
		let html = document.createElement('div');
		html.innerHTML = data;

		// JSON-Objekt erstellen
		let json = response.contentType == 'application/json' && html.innerText !== '' ? JSON.parse(html.innerText) : {};

		// Meldungen anzeigen
		opaccLogPlugin.showMessages(response.messages, json);

		return {
			// Informationen aus Response-Objekt
			status: response.status,
			messages: response.messages,
			dataAsBase64: response.data,
			contentType: response.contentType,
			// Aufbereitete Informationen
			success: response.status == 'ok',
			dataAsHtml: response.contentType == 'text/html' ? html.innerText : '',
			dataAsJson: json,
			data: data
		};
	}

    /**
     * Returns decoded Utf8 string
     * @param {string} encoded Utf8 encoded string
     * @returns string
     */
    base64DecodeUnicode(encoded) {
        // Going backwards: from bytestream, to percent-encoding, to original string.
        return window.decodeURIComponent(window.atob(encoded).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    /**
     *
     * @param {boolean} checkForReadOnlyContext Soll geprüft werden, ob die Daten nur lesend geladen werden sollen?
     * @returns URL für die asynchrone Abfrage
     */
    setAsyncUrl(checkForReadOnlyContext = false) {
        let asyncUrl = '/WebPortal/async.aspx';

        if (!(window.opacc && window.opacc.systemUrls)) {
            return asyncUrl;
        }

        if (checkForReadOnlyContext) {
            if (window.opacc.systemUrls.asyncReadOnly) {
                asyncUrl = window.opacc.systemUrls.asyncReadOnly;
            } else if (window.opacc.systemUrls.async) {
                asyncUrl = window.opacc.systemUrls.async;
            }
        }

        return asyncUrl;
    }

	/**
	 *
	 *
	 * @param {*} response
	 * @returns {*}
	 */
	doNothing(response) {
		return response;
	}
}